export default "__VITE_ASSET__BTLFEexb__"